export const ERROR_MODE_WIDGET = 'widget';
export const ERROR_MODE_HEADER = 'header';
export const ERROR_MODE_PAGE = 'page';
